//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import ButtonAction from '@react/components/elements/ButtonAction'
import { useAppKit } from '@reown/appkit/react'
import React from 'react'

export default function ConnectButtonAppKit(): React.ReactElement {
  const appKit = useAppKit()

  if (!appKit) {
    return <></>
  }

  return (
    <ButtonAction
      variant={'primary'}
      onClick={() => {
        appKit?.open({ view: 'Connect' })
      }}
    >
      Connect
    </ButtonAction>
  )
}
